import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import styles from "./Button.module.scss";

const Button = ({
  text,
  onClick,
  className,
  isLink,
  slug,
  type,
  icon,
  style,
  disabled,
  ...props
}) => {
  return !isLink ? (
    <button
      style={style}
      className={`${styles[className]} ${styles.button}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
      {...props}
    >
      {icon && icon}
      {text}
    </button>
  ) : (
    <Link
      className={`${styles[className]} ${styles.button}`}
      to={slug}
    >
      {icon && icon}
      {text}
    </Link>
  );
};

Button.propTypes = {
  style: PropTypes.object,
  text: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isLink: PropTypes.bool,
  slug: PropTypes.string,
  type: PropTypes.string,
  icon: PropTypes.node,
  disabled: PropTypes.bool
};

Button.defaultProps = {
  style: {},
  className: "primary",
  text: "click here",
  onClick: () => {},
  isLink: false,
  slug: "#",
  type: "button",
  disabled: false
};

export default Button;
